import { useEffect, useState } from 'react'
import { Link, useParams } from 'react-router-dom'
import { getWalletReceipt, type WalletReceipt } from '../api/wallet'

export default function WalletReceiptPage() {
  const { entryId } = useParams()
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState<string | null>(null)
  const [receipt, setReceipt] = useState<WalletReceipt | null>(null)

  useEffect(() => {
    if (!entryId) return
    setLoading(true)
    setError(null)
    getWalletReceipt(entryId)
      .then(setReceipt)
      .catch((e: any) => setError(e?.response?.data?.detail || e?.message || 'Failed to load receipt'))
      .finally(() => setLoading(false))
  }, [entryId])

  if (loading) return <div className="p-6 text-white">Loading receipt...</div>
  if (error) return <div className="p-6 text-rose-300">{error}</div>
  if (!receipt) return <div className="p-6 text-white">Receipt not found.</div>

  const chain = receipt.blockchain || {}
  const txHash = chain.tx_hash || ''

  return (
    <div className="mx-auto max-w-3xl p-6 text-white space-y-4">
      <h1 className="text-2xl font-extrabold">Transfer Receipt</h1>
      <div className="rounded-xl border border-white/10 bg-white/5 p-4 space-y-2">
        <div><strong>Amount:</strong> {receipt.amount_display || `${receipt.amount_pixe} PIXE`}</div>
        <div><strong>Status:</strong> {chain.chain_status || 'submitted'}</div>
        <div><strong>Date:</strong> {new Date(receipt.created_at).toLocaleString()}</div>
        {receipt.memo ? <div><strong>Memo:</strong> {receipt.memo}</div> : null}
        <div><strong>From:</strong> {(receipt.sender?.display_name || 'Unknown')} {(receipt.sender?.handle || '')}</div>
        <div className="break-all"><strong>From SS58:</strong> {receipt.sender?.ss58 || '-'}</div>
        <div><strong>To:</strong> {(receipt.recipient?.display_name || 'Unknown')} {(receipt.recipient?.handle || '')}</div>
        <div className="break-all"><strong>To SS58:</strong> {receipt.recipient?.ss58 || '-'}</div>
        <div className="break-all"><strong>Tx Hash:</strong> {txHash || 'pending / not available'}</div>
        <div><strong>Block:</strong> {chain.block_number ?? 'pending'}</div>
        {chain.fee_pixe ? <div><strong>Fee:</strong> {chain.fee_pixe} PIXE</div> : null}
      </div>
      <div className="flex items-center gap-3">
        <Link className="rounded-lg border border-white/20 px-3 py-2 hover:bg-white/10" to="/settings/wallet?tab=activity">
          Back to wallet
        </Link>
        {chain.explorer_url ? (
          <a className="rounded-lg border border-sky-400/40 px-3 py-2 text-sky-200 hover:bg-sky-600/20" href={chain.explorer_url} target="_blank" rel="noreferrer">
            View on chain
          </a>
        ) : null}
      </div>
    </div>
  )
}

